import { render, staticRenderFns } from "./BusinessArea.vue?vue&type=template&id=271bb3a2&"
import script from "./BusinessArea.vue?vue&type=script&lang=js&"
export * from "./BusinessArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports